import $ from "jquery";


const CustomSelect = () => {
    $("body").on("click",".custom-select .current-option", function () {
        $(this).parent().find("ul").slideToggle("fast");
        $(this).parent().toggleClass("custom-select--open");
    });

    $("body").on("click",".custom-select ul li", function () {
        
        let customSelect = $(this).parent().parent();
        let customSelectInput = $(this).parent().parent().find("input");
        $(this).parent().slideToggle("fast");
        $(customSelect).toggleClass("custom-select--open");
        $(customSelect).find(".current-option").html($(this).text()+'<i class="fa-solid fa-chevron-down"></i>');

        $(customSelectInput).val($(this).attr("data-value"));
        $(customSelectInput).trigger("change");
    });
}

CustomSelect();
